// extracted by mini-css-extract-plugin
module.exports = {"calendar-preview":"Preview_calendar-preview__2s0oj","today":"Preview_today__eOy2g","done":"Preview_done__3eNNT","more":"Preview_more__317BS"};